<!-- eslint-disable vue/no-v-html -->
<template>
    <ul
        v-if="items.length > 0"
        class="structure-slot-benefit-list flex flex-wrap gap-2 pt-6 pb-8 list-none p-0 m-0 w-full max-w-none!"
        :class="alignmentClass"
    >
        <li
            v-for="(item, index) in items"
            :key="index"
            :class="itemClasses"
        >
            <MiscModal
                v-if="hasModal(item)"
                class="w-full"
                :button-classes="cardClasses"
            >
                <template #button>
                    <StructureSlotBenefitListCard :item="item" />
                </template>
                <template #content>
                    <h3
                        v-if="item.modalHeadline"
                        class="font-bold text-3xl text-link"
                    >
                        {{ item.modalHeadline }}
                    </h3>
                    <div
                        v-if="item.modalText"
                        class="prose max-w-none prose-headings:text-link prose-headings:font-semibold py-4 text-lg"
                        v-html="item.modalText"
                    />
                </template>
            </MiscModal>

            <div
                v-else
                :class="cardClasses"
            >
                <StructureSlotBenefitListCard :item="item" />
            </div>
        </li>
    </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblBenefitListAlignment, HblBenefitListItem, HblSlot } from '@/utils/types'

const MAX_ITEMS = 4

const props = defineProps<{
    content: HblSlot
}>()

function isBenefitListItem (value: unknown): value is HblBenefitListItem {
    return typeof value === 'object' && value !== null && typeof (value as HblBenefitListItem).title === 'string'
}

const items = computed<HblBenefitListItem[]>(() => {
    const data = props.content.data
    if (typeof data !== 'object' || data === null || !Array.isArray(data.items)) {
        return []
    }

    return data.items
        .filter(isBenefitListItem)
        .filter(item => item.title !== '')
        .slice(0, MAX_ITEMS)
})

const alignment = computed<HblBenefitListAlignment>(() => {
    const config = props.content.config?.alignment as { value?: unknown } | undefined
    return config?.value === 'between' ? 'between' : 'center'
})

const alignmentClass = computed(() => alignment.value === 'between' ? 'justify-center xl:justify-between' : 'justify-center')

const itemClasses = 'flex w-full p-3 sm:w-auto sm:grow-0 sm:basis-[calc(50%-0.25rem)] xl:basis-[calc(25%-0.375rem)]'

const cardClasses = 'flex flex-col items-center text-center gap-4 w-full'

function hasModal (item: HblBenefitListItem): boolean {
    return Boolean(item.modalHeadline || item.modalText)
}
</script>
